module.exports = __webpack_public_path__ + "static/media/logo-backoffice.01aba977.png";